module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/logo_leaders-834135216c84f496a97ed9503c44c7d3.svg";